<template>
  <vz-button
    large
    variant="primary"
    :icon-name="hasIcon ? iconName : ''"
    :icon-right="!iconLeft"
    :icon-left="iconLeft"
    :icon-size="iconSize"
    :to="{ name: 'personal' }"
    class="public-auth-button"
    @click="onClick"
  >
    {{ title }}
  </vz-button>
</template>

<script setup lang="ts">
const props = defineProps({
  title: {
    type: String,
    default: 'Зарегистрироваться в личном кабинете'
  },
  hasIcon : {
    type: Boolean,
    default: true
  },
  iconName: {
    type: String,
    default: 'arrow-right'
  },
  iconLeft: {
    type: Boolean,
    default: false,
  },
  iconSize: {
    type: Number,
    default: 18
  }
})

function onClick() {
  if (VK) {
    VK?.Retargeting.Event('click-registration');
  }
}
</script>

<style lang="scss" scoped>
  .public-auth-button {
    @media screen and (max-width: $pub-xs) {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
</style>
